import { Injectable } from '@angular/core';
import { ScreenSharingApiService } from 'src/app/api/services/screen-sharing-api.service';
import { LocalStorageHelperService } from 'src/app/shared/services/local-storage-helper.service';
import { ModeratorWebsocketParamsService } from '../types/moderator-params';
import { ScreenSharingMode } from '../types/screen-sharing-mode';
import { Session } from '../types/session';
import { CryptoUtilsService } from 'src/app/shared/services/crypto-utils.service';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';

@Injectable({
  providedIn: 'root',
})
export class ScreenSharingSessionService {
  constructor(
    private localStoreService: LocalStorageHelperService,
    private screenSharingApiService: ScreenSharingApiService,
    private companyStateService: CompanyStateService,
    private cryptoUtilsService: CryptoUtilsService,
  ) {}

  generateSessionId() {
    return `MOD-${this.companyStateService.getSelectedCompanyId()}-${this.cryptoUtilsService.randomUUID().split('-')[0]}`;
  }

  async findSessionIfExists(): Promise<Session | null> {
    const sessionId: string = this.localStoreService.get(
      ModeratorWebsocketParamsService.MODERATOR_SESSION_KEY,
    );

    if (sessionId) {
      const session = await this.getModeratedSession(sessionId);
      if (!session) {
        this.localStoreService.remove(
          ModeratorWebsocketParamsService.MODERATOR_SESSION_KEY,
        );
      }
      return session;
    }
    return null;
  }

  async getModeratedSession(sessionId: string): Promise<Session | null> {
    try {
      const session = await this.screenSharingApiService.getSession(sessionId);
      return session?.screenSharingMode === ScreenSharingMode.MODERATED
        ? session
        : null;
    } catch {
      return null;
    }
  }

  async getCompanySessions(
    screenSharingMode?: ScreenSharingMode,
  ): Promise<Session[] | null> {
    try {
      const sessions =
        await this.screenSharingApiService.getCompanySessions(
          screenSharingMode,
        );
      return sessions;
    } catch {
      return null;
    }
  }

  async deleteSession(sessionId: string): Promise<void> {
    try {
      await this.screenSharingApiService.deleteSession(sessionId);
    } catch (error) {
      throw new Error('Failed to delete session', error);
    }
  }
}
